import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BpInlineNotificationComponent } from "./bp-inline-notification.component";

@NgModule({
	declarations: [BpInlineNotificationComponent],
	exports: [BpInlineNotificationComponent],
	imports: [CommonModule]
})
export class BpInlineNotificationModule {}
